// 导入音频文件作为 Vite 资产
import audio1 from './src/assets/01-city-neon.mp3?url';
import audio2 from './src/assets/02-mountain-breeze.mp3?url';
import audio3 from './src/assets/03-light-chaser.mp3?url';
import audio4 from './src/assets/04-dream-chaser.mp3?url';

// 将音频URL暴露到全局作用域
window.PRESET_AUDIO_URLS = {
  audio1,
  audio2,
  audio3,
  audio4
};

console.log('Preset audio URLs loaded in main.js:', window.PRESET_AUDIO_URLS);

// CD播放器核心逻辑
class CDPlayer {
  constructor() {
    this.playlist = [];
    this.currentTrack = 0;
    this.isPlaying = false;
    this.isPaused = false;
    this.volume = 50;
    this.audio = new Audio();
    this.rotationAngle = 0;

    this.initElements();
    this.initEventListeners();
    this.initVolumeKnob();
    this.autoLoadPresetSongs();
  }

  initElements() {
    // 控制按钮
    this.playBtn = document.getElementById('playBtn');
    this.stopBtn = document.getElementById('stopBtn');
    this.nextBtn = document.getElementById('nextBtn');
    this.prevBtn = document.getElementById('prevBtn');

    // LCD显示
    this.trackNumberEl = document.getElementById('trackNumber');
    this.trackNameEl = document.getElementById('trackName');
    this.currentTimeEl = document.getElementById('currentTime');

    // CD元素
    this.cdDisc = document.getElementById('cdDisc');
    this.cdContainer = document.getElementById('cdContainer');
    this.loadingAnimation = document.getElementById('loadingAnimation');

    // 文件上传
    this.audioFilesInput = document.getElementById('audioFiles');

    // 音量旋钮
    this.volumeKnob = document.getElementById('volumeKnob');
  }

  initEventListeners() {
    // 播放控制 - Play按钮切换播放/暂停
    this.playBtn.addEventListener('click', () => this.togglePlay());
    this.stopBtn.addEventListener('click', () => this.stop());
    this.nextBtn.addEventListener('click', () => this.next());
    this.prevBtn.addEventListener('click', () => this.prev());

    // 文件上传
    this.audioFilesInput.addEventListener('change', (e) => this.loadFiles(e));

    // 音频事件
    this.audio.addEventListener('timeupdate', () => this.updateTime());
    this.audio.addEventListener('ended', () => this.next());
  }

  initVolumeKnob() {
    let isDragging = false;
    let startAngle = 0;
    let currentRotation = 0;

    const getAngle = (e) => {
      const rect = this.volumeKnob.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      const x = (e.clientX || e.touches[0].clientX) - centerX;
      const y = (e.clientY || e.touches[0].clientY) - centerY;
      return Math.atan2(y, x) * (180 / Math.PI);
    };

    const startDrag = (e) => {
      isDragging = true;
      startAngle = getAngle(e);
      e.preventDefault();
    };

    const drag = (e) => {
      if (!isDragging) return;

      const currentAngle = getAngle(e);
      let delta = currentAngle - startAngle;

      // 处理角度跨越
      if (delta > 180) delta -= 360;
      if (delta < -180) delta += 360;

      currentRotation += delta;

      // 限制旋转范围 (-135° 到 +135°，共270°)
      currentRotation = Math.max(-135, Math.min(135, currentRotation));

      // 计算音量 (0-100)
      this.volume = Math.round(((currentRotation + 135) / 270) * 100);

      // 更新旋钮视觉
      this.volumeKnob.style.transform = `rotate(${currentRotation}deg)`;

      // 更新音量
      this.setVolume(this.volume);

      startAngle = currentAngle;
      e.preventDefault();
    };

    const endDrag = () => {
      isDragging = false;
    };

    // 鼠标事件
    this.volumeKnob.addEventListener('mousedown', startDrag);
    document.addEventListener('mousemove', drag);
    document.addEventListener('mouseup', endDrag);

    // 触摸事件
    this.volumeKnob.addEventListener('touchstart', startDrag);
    document.addEventListener('touchmove', drag);
    document.addEventListener('touchend', endDrag);

    // 设置初始旋转
    const initialRotation = ((this.volume / 100) * 270) - 135;
    this.volumeKnob.style.transform = `rotate(${initialRotation}deg)`;
  }

  setVolume(value) {
    this.volume = Math.max(0, Math.min(100, value));
    this.audio.volume = this.volume / 100;
  }

  async loadFiles(e) {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    // 显示加载动画
    this.loadingAnimation.classList.add('active');

    // 模拟CD加载延迟
    await new Promise(resolve => setTimeout(resolve, 800));

    this.playlist = files.map((file, index) => ({
      file,
      name: file.name.replace(/\.[^/.]+$/, ""),
      url: URL.createObjectURL(file),
      index: index + 1
    }));

    this.currentTrack = 0;
    this.loadTrack(this.currentTrack);

    // CD插入动画
    this.cdDisc.classList.remove('loaded');
    setTimeout(() => {
      this.cdDisc.classList.add('loaded');
      this.loadingAnimation.classList.remove('active');
    }, 100);
  }

  loadTrack(index) {
    if (index < 0 || index >= this.playlist.length) return;

    this.currentTrack = index;
    const track = this.playlist[index];

    console.log('Loading track:', track.name, track.url);

    // 设置跨域属性以支持外部音频资源
    this.audio.crossOrigin = 'anonymous';
    this.audio.src = track.url;
    this.audio.load();

    // 添加错误处理
    this.audio.onerror = (e) => {
      console.error('Audio load error:', e);
      console.error('Failed URL:', track.url);
      this.trackNameEl.textContent = 'Load Failed';

      // 显示详细错误信息
      if (this.audio.error) {
        console.error('Error code:', this.audio.error.code);
        console.error('Error message:', this.audio.error.message);
      }
    };

    // 添加加载成功回调
    this.audio.onloadedmetadata = () => {
      console.log('Audio loaded successfully:', track.name);
    };

    this.updateLCD();

    // 如果之前在播放，自动播放新曲目
    if (this.isPlaying) {
      this.audio.play().catch(err => {
        console.error('Playback error:', err);
      });
    }
  }

  updateLCD() {
    if (this.playlist.length === 0) {
      this.trackNumberEl.textContent = '00';
      this.trackNameEl.textContent = 'No Disc';
      this.trackNameEl.classList.remove('scrolling');
      return;
    }

    const track = this.playlist[this.currentTrack];
    this.trackNumberEl.textContent = String(track.index).padStart(2, '0');

    // 移除滚动效果
    this.trackNameEl.classList.remove('scrolling');
    this.trackNameEl.textContent = track.name;

    // 检查文字是否溢出
    setTimeout(() => {
      if (this.trackNameEl.scrollWidth > this.trackNameEl.clientWidth) {
        // 如果溢出，添加滚动效果
        this.trackNameEl.innerHTML = `<span data-text="${track.name}">${track.name}</span>`;
        this.trackNameEl.classList.add('scrolling');
      }
    }, 100);
  }

  updateTime() {
    if (isNaN(this.audio.currentTime) || !isFinite(this.audio.currentTime)) return;
    const mins = Math.floor(this.audio.currentTime / 60);
    const secs = Math.floor(this.audio.currentTime % 60);
    this.currentTimeEl.textContent = `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  }

  togglePlay() {
    if (this.playlist.length === 0) {
      this.showMessage('Insert CD');
      return;
    }

    if (this.isPlaying) {
      this.pause();
    } else {
      this.play();
    }
  }

  play() {
    this.audio.play();
    this.isPlaying = true;
    this.isPaused = false;

    // CD旋转动画
    this.cdDisc.classList.add('spinning');

    // 更新UI
    this.playBtn.classList.add('active');
    this.playBtn.querySelector('.btn-icon').textContent = '⏸';
    this.playBtn.querySelector('.btn-label').textContent = 'PAUSE';
    this.stopBtn.classList.remove('active');
  }

  pause() {
    this.audio.pause();
    this.isPlaying = false;
    this.isPaused = true;

    // 停止CD旋转
    this.cdDisc.classList.remove('spinning');

    // 更新UI
    this.playBtn.classList.remove('active');
    this.playBtn.querySelector('.btn-icon').textContent = '▶';
    this.playBtn.querySelector('.btn-label').textContent = 'PLAY';
  }

  stop() {
    this.audio.pause();
    this.audio.currentTime = 0;
    this.isPlaying = false;
    this.isPaused = false;

    // 停止CD旋转
    this.cdDisc.classList.remove('spinning');

    // 更新UI
    this.playBtn.classList.remove('active');
    this.playBtn.querySelector('.btn-icon').textContent = '▶';
    this.playBtn.querySelector('.btn-label').textContent = 'PLAY';
    this.stopBtn.classList.add('active');

    setTimeout(() => {
      this.stopBtn.classList.remove('active');
    }, 300);
  }

  next() {
    if (this.playlist.length === 0) return;

    const nextIndex = (this.currentTrack + 1) % this.playlist.length;
    this.loadTrack(nextIndex);

    // 按钮动画
    this.nextBtn.classList.add('active');
    setTimeout(() => this.nextBtn.classList.remove('active'), 200);
  }

  prev() {
    if (this.playlist.length === 0) return;

    const prevIndex = (this.currentTrack - 1 + this.playlist.length) % this.playlist.length;
    this.loadTrack(prevIndex);

    // 按钮动画
    this.prevBtn.classList.add('active');
    setTimeout(() => this.prevBtn.classList.remove('active'), 200);
  }

  showMessage(msg) {
    const originalText = this.trackNameEl.textContent;
    this.trackNameEl.textContent = msg;
    setTimeout(() => {
      this.trackNameEl.textContent = originalText;
    }, 2000);
  }

  // 自动加载预设歌曲
  async autoLoadPresetSongs() {
    console.log('Starting to load preset songs...');

    // 开发环境:使用 Vite 资产导入(仅在开发时可用)
    const presetSongs = [
      { name: '追光者', url: audio3 },
      { name: '逐梦者', url: audio4 }
    ];

    // 显示加载动画
    this.loadingAnimation.classList.add('active');
    this.trackNameEl.textContent = 'Loading CD...';

    // 模拟CD加载延迟
    await new Promise(resolve => setTimeout(resolve, 1200));

    this.playlist = presetSongs.map((song, index) => ({
      name: song.name,
      url: song.url,
      index: index + 1
    }));

    console.log('Playlist created:', this.playlist);

    this.currentTrack = 0;
    this.loadTrack(this.currentTrack);

    // CD插入动画
    this.cdDisc.classList.remove('loaded');
    setTimeout(() => {
      this.cdDisc.classList.add('loaded');
      this.loadingAnimation.classList.remove('active');
      console.log('CD loaded and visible');
    }, 100);
  }
}

// 初始化播放器
document.addEventListener('DOMContentLoaded', () => {
  const player = new CDPlayer();

  // 全局键盘快捷键
  document.addEventListener('keydown', (e) => {
    switch(e.key) {
      case ' ':
        e.preventDefault();
        player.togglePlay();
        break;
      case 'ArrowRight':
        e.preventDefault();
        player.next();
        break;
      case 'ArrowLeft':
        e.preventDefault();
        player.prev();
        break;
      case 'Escape':
        e.preventDefault();
        player.stop();
        break;
    }
  });
});
